const hasModalElem = document.querySelector('.modal');

if (hasModalElem) {
  attachEvent('.has-modal .btn', 'click', (ev) => {
    const parentEle = ev.target.closest('.get-in-touch__item');
    const modal = parentEle.querySelector('.modal');
    modal.classList.add('is-open-modal');
    toggleBodyScrollLock(true);
    ev.preventDefault();
  });
}
